import { render, staticRenderFns } from "./TrainResIndex.vue?vue&type=template&id=2bac55a5&scoped=true"
import script from "./TrainResIndex.vue?vue&type=script&lang=js"
export * from "./TrainResIndex.vue?vue&type=script&lang=js"
import style0 from "./TrainResIndex.vue?vue&type=style&index=0&id=2bac55a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bac55a5",
  null
  
)

export default component.exports